import { createFileRoute } from "@tanstack/react-router";
import AdminNewsletter from "@/pages/admin/AdminNewsletter";

export const Route = createFileRoute("/admin/newsletter")({
  component: AdminNewsletter,
});
